<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 5.5L8 9.5L12 5.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>